if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.accessories = this.querySelectorAll('[name="upsell_accesories"]')
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });

        // update price in the buy button when accessories selected
        if(this.accessories.length > 0) {
          this.accessories.forEach((el) => {
            el.addEventListener('change', (e) => {
              // the inline span only exists when custom.add_to_cart_button_text_override placed the price itself
              const inlinePrice = this.submitButton.querySelector('.product-form__submit-price-inline');
              const suffixPrice = this.submitButton.querySelector('.product-form__submit-price');
              if (!inlinePrice && !suffixPrice) return;

              const originalPrice = Number(this.submitButton.dataset.price)
              let totalPrice = originalPrice;

              this.accessories.forEach((acc) => {
                if (acc.checked) {
                  totalPrice += Number(acc.dataset.value)
                }
              })

              totalPrice = totalPrice/100
              totalPrice = Number.isInteger(totalPrice) ? totalPrice : totalPrice.toFixed(2)

              if (inlinePrice) {
                inlinePrice.textContent = `${window.currencySymbol}${(totalPrice)}`;
              } else {
                suffixPrice.innerHTML = `&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;${window.currencySymbol}${(totalPrice)}`;
              }
            })
          })
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

if (!customElements.get('size-guide-link')) {
  customElements.define(
  'size-guide-link',
  class SizeGuideLink extends HTMLElement {
    constructor() {
      super();

      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');

      this.scrollToSizeGuide = () => {
        const detailsSizing = document.getElementById('details-sizing');
        const headerHeight = document.querySelector('header')?.clientHeight || 0;
        let target = detailsSizing;

        if (detailsSizing?.querySelector('size-details-toggle')) {
          const wrapper = detailsSizing.querySelector('.product-accordion_wrapper');
          if (wrapper && !wrapper.classList.contains('open')) {
            wrapper.querySelector('.product-accordian__trigger')?.click();
          }
        } else {
          target =
            document.querySelector('.section-compare-sizes') ||
            document.querySelector('.size-comparison-banner');
        }

        if (!target) return;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - headerHeight,
          left: 0,
          behavior: 'smooth',
        });
      };

      this.addEventListener('click', this.scrollToSizeGuide);
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.scrollToSizeGuide();
        }
      });
    }
  });
}

if (!customElements.get('video-handler')) {
  class VideoHandler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(this.querySelector('button').getAttribute('data-event-added') === 'true') return;
      this.querySelector('button').addEventListener('click', (e) => {
        const video = e.target.closest('.product-media-container').querySelector('video')
        if(video.paused) {
          e.target.setAttribute('data-video-state', 'playing')
          video.play()
        } else {
          e.target.setAttribute('data-video-state', 'paused')
          video.pause()
        }
      })
      this.querySelector('button').setAttribute('data-event-added', 'true')
    }
  }
  customElements.define('video-handler', VideoHandler)
}

if (!customElements.get('color-group-tabs')) {
  class ColorGroupTabs extends HTMLElement {
    constructor() {
      super();

      this.parent = this.closest('.color-options-wrapper');
      this.selectedPill = this.querySelector('[role="tab"][aria-selected="true"]')
    }

    connectedCallback() {
      if (this.selectedPill) {
        const swiperWrapper = this.selectedPill.closest('.swiper');
        if (swiperWrapper) {
          const pillOffset = this.selectedPill.offsetLeft;
          // Scroll the swiper container
          swiperWrapper.scrollTo({
            left: pillOffset
          });
        }
      }
    }
  }
  customElements.define('color-group-tabs', ColorGroupTabs)
}

if (!customElements.get('associated-variant-radios')) {
  const associatedVariantBodyScrollLock = {
    count: 0,
    lock() {
      this.count += 1;
      if (this.count === 1) {
        document.body.classList.add('overflow-hidden');
      }
    },
    unlock() {
      this.count = Math.max(0, this.count - 1);
      if (this.count === 0 && !document.body.classList.contains('cart-drawer-open')) {
        document.body.classList.remove('overflow-hidden');
      }
    },
  };

  class AssociatedVariantRadios extends HTMLElement {
    constructor() {
      super();
      this.currentVariant = null;
      this.activeColorDrawer = null;
      this.fetchAbortController = null;
      this._initializing = false;

      this._onChange = this.onVariantChange.bind(this);
      this._onClick = this._handleClick.bind(this);
      this._onMouseOver = this.mouseOverOutChange.bind(this);
      this._onMouseOut = this.mouseOverOutChange.bind(this);
    }

    connectedCallback() {
      if (this.dataset.layout === 'tabs' && !this.querySelector('.color-group-tabs-wrapper')) {
        this.renderTabs();
      }

      this._initMobileScroll();

      this.addEventListener('change', this._onChange);
      this.addEventListener('click', this._onClick);
      this.addEventListener('mouseover', this._onMouseOver);
      this.addEventListener('mouseout', this._onMouseOut);

      this.manageOutOfStockStatus();
      this.updateOptionLabels();
      this.updateSizeDescription();
    }

    disconnectedCallback() {
      this.fetchAbortController?.abort();
      this.removeEventListener('change', this._onChange);
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('mouseover', this._onMouseOver);
      this.removeEventListener('mouseout', this._onMouseOut);
      this._closeActiveColorDrawer(true);
    }

    _initMobileScroll() {
      if (!this.classList.contains('mobile-scroll__on') || window.outerWidth >= 749) return;

      const selectedGroupWrapper = this.querySelector('[data-selected-group="true"]');
      const selected = selectedGroupWrapper?.querySelector('input:checked + label');
      if (!selectedGroupWrapper || !selected) return;

      const wrapperRect = selectedGroupWrapper.getBoundingClientRect();
      const selectedRect = selected.getBoundingClientRect();
      const scrollLeft = selectedGroupWrapper.scrollLeft;
      const offset = selectedRect.left - wrapperRect.left;
      const centerOffset = offset - (wrapperRect.width / 2) + (selectedRect.width / 2);

      selectedGroupWrapper.scrollTo({
        left: scrollLeft + centerOffset,
        behavior: 'instant',
      });
    }

    _handleClick(event) {
      const showMoreButton = event.target.closest('button.show__more-colors');
      const hideMoreButton = event.target.closest('button.hide__more-colors');

      if (showMoreButton) {
        const parentWrapper = showMoreButton.closest('.color-group__options');
        if (!parentWrapper) return;

        if (parentWrapper.classList.contains('color-group__options-overlay')) {
          this.createSwatchesDrawerOverlay(parentWrapper);
        } else {
          this._setGroupExpanded(parentWrapper, true);
        }
        return;
      }

      if (hideMoreButton) {
        const parentWrapper = hideMoreButton.closest('.color-group__options');
        if (parentWrapper) {
          this._setGroupExpanded(parentWrapper, false);
        }
      }
    }

    _setGroupExpanded(parentWrapper, expanded) {
      parentWrapper.classList.toggle('hide__options', !expanded);
      parentWrapper.querySelector('button.show__more-colors')?.classList.toggle('hidden', expanded);
      parentWrapper.querySelector('button.hide__more-colors')?.classList.toggle('hidden', !expanded);
    }

    _closeActiveColorDrawer(force = false) {
      const drawer = this.activeColorDrawer;
      if (!drawer) return;

      drawer.classList.remove('open');
      associatedVariantBodyScrollLock.unlock();

      const removeDrawer = () => {
        if (drawer.isConnected) {
          drawer.remove();
        }
        if (this.activeColorDrawer === drawer) {
          this.activeColorDrawer = null;
        }
      };

      if (force) {
        removeDrawer();
      } else {
        setTimeout(removeDrawer, 300);
      }
    }

    mouseOverOutChange(e) {
      if (!deviceSupportHover()) return;
      if (!e.target.closest('.option-color-label')) return;

      const colorName = e.target.dataset.colorName;
      if (!colorName) return;

      const legendColorEl = this.querySelector('.color-options-wrapper__legend .option-selected-value');
      const targetEl = e.target.closest('[data-group-name]')?.querySelector('.color-group__label p span');

      if(e.type === 'mouseover') {
        if (legendColorEl) {
          legendColorEl.textContent = `${colorName}`;
        }
        if (targetEl) {
          targetEl.innerHTML = `<span>&nbsp;|&nbsp;</span>${colorName}`;
        }
      } else {
        const selectedSwatch = this.querySelector('input[name="Color"]:checked');
        const restoreColor = selectedSwatch?.value;

        if (legendColorEl && restoreColor) {
          legendColorEl.textContent = `${restoreColor}`;
          legendColorEl.dataset.selectedColor = restoreColor;
        }
        if (targetEl) {
          if(targetEl.classList.contains('selected__color')) {
            targetEl.innerHTML = `<span>&nbsp;|&nbsp;</span>${targetEl.dataset.selectedColor}`;
          } else {
            targetEl.innerHTML = '&nbsp;'
          }
        }
      }
    }

    createSwatchesDrawerOverlay(parentWrapper) {
      this._closeActiveColorDrawer(true);

      const overlayDrawer = document.createElement('div');
      overlayDrawer.classList.add('color-group__options-drawer');
      this.activeColorDrawer = overlayDrawer;
      overlayDrawer.setAttribute('aria-hidden', 'false');
      overlayDrawer.setAttribute('role', 'dialog');
      overlayDrawer.setAttribute('aria-labelledby', 'swatches-drawer-title');
      overlayDrawer.setAttribute('aria-describedby', 'swatches-drawer-description');
      overlayDrawer.setAttribute('aria-modal', 'true');

      let drawerInnerHTML = ``;

      parentWrapper.querySelectorAll('input').forEach((el) => {
        const label = el.nextElementSibling;

        drawerInnerHTML += `
          <div class="color-group__options-drawer__swatch">
            <input class="${el.getAttribute('class')}" type="radio" id="${el.id}-overlay" name="${el.name}-overlay" value="${el.value}" data-value="${el.dataset.value}" ${el.checked ? 'checked' : ''} />
            <label for="${el.id}-overlay">
              <div>
                ${label.innerHTML.replace(/width=100/g, 'width=250')}
              </div>
              <span>${el.value}</span>
            </label>
          </div>
        `;
      });

      overlayDrawer.innerHTML = `
        <span class="drawer__overlay" aria-hidden="true"></span>
        <div class="color-group__options-drawer__content">
          <button class="close-drawer__icon small-hide" aria-label="Close color options">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M19 1L0.999998 18.9999" stroke="black" stroke-width="2"/>
              <path d="M19 19L0.999998 1.0001" stroke="black" stroke-width="2"/>
            </svg>
          </button>
          <button class="close-drawer__icon medium-hide large-up-hide" aria-label="Close color options">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
              <path d="M6.66602 11L1.99935 6L6.66601 1" stroke="black" stroke-width="1.5"/>
            </svg>
            Back
          </button>
          <div class="color-group__options-drawer__swatches">
            ${drawerInnerHTML}
          </div>
          <button class="color-group__select button button--primary-black" type="button" aria-label="Select color option">
            Select
          </button>
        </div>
      `;

      document.querySelector('#MainContent')?.appendChild(overlayDrawer);

      requestAnimationFrame(() => {
        associatedVariantBodyScrollLock.lock();
        overlayDrawer.classList.add('open');
      });

      const closeDrawer = () => this._closeActiveColorDrawer();

      overlayDrawer.querySelectorAll('.close-drawer__icon, span.drawer__overlay, button.color-group__select').forEach((el) => {
        el.addEventListener('click', closeDrawer);
      });

      overlayDrawer.querySelectorAll('input[type="radio"]').forEach((swatch) => {
        swatch.addEventListener('change', () => {
          const selectedSwatch = overlayDrawer.querySelector('input[type="radio"]:checked');
          if (!selectedSwatch) return;

          const originalId = selectedSwatch.id.split('-overlay')[0];
          const originalSwatch = parentWrapper.querySelector(`input#${originalId}`);
          if (!originalSwatch) return;

          originalSwatch.checked = true;
          originalSwatch.dispatchEvent(new Event('change', { bubbles: true }));
          closeDrawer();
        });
      });
    }

    closeSwatchesOverlayDrawer(drawer) {
      if (drawer && this.activeColorDrawer === drawer) {
        this._closeActiveColorDrawer();
      }
    }

    renderTabs() {
      const parentWrapper = this.querySelector('.color-options-wrapper');
      if(!parentWrapper) return;

      // get all swatches/styles
      const allOptions = parentWrapper.querySelectorAll('input[name="Color"]');
      if(allOptions.length <= 0) return;

      // get default selected group
      const defaultSelectedGroup = parentWrapper.querySelector('[data-group-name][data-group-selected="true"]');
      const defaultSelectedName = defaultSelectedGroup?.dataset.groupName;

      // get the product type
      const productType = this.dataset.productType;

      // create tabs
      const tabs = document.createElement('div');
      tabs.classList.add('color-group-tabs-wrapper')
      let innerTabsHtml = '';

      const tabsArray = [{name: "All", id: "all"}];
      allOptions.forEach((el) => {
        const groupName = el.dataset.group?.trim();
        if(!tabsArray.some(tab => tab.name === groupName) && groupName !== '') {
          tabsArray.push({
            name: groupName,
            id: el.dataset.groupId
          });
        }
      });

      // get the selected tab if tab is changed and page is not refreshed and also check if the url contains the specific tab name to be selected example: url?tab=all
      const urlParams = new URLSearchParams(window.location.search);
      // Default to All so the server-rendered grid needs no post-paint correction.
      const preSelectedTab = urlParams.get('tab')
        || document.querySelector('.product--content').dataset.selectedTab
        || 'all';

      tabsArray.forEach((tab, i) => {
        innerTabsHtml += `
          <div class="swiper-slide">
            <button
            role="tab"
            id="tab-${tab.id}-${i}"
            aria-selected="${preSelectedTab === tab.id ? 'true' : 'false'}"
            aria-controls="${tab.id}"
            class="tab">
              ${tab.name}
            </button>
          </div>
        `;
      });

      if(innerTabsHtml !== '') {
        tabs.innerHTML = `
        ${productType === 'bogg-bit' ?
          `<div class="color-group__label"><p>Bits Style: <span>${defaultSelectedName}</span></p></div>`
          : ''
        }
        <color-group-tabs class="${tabsArray.length < 3 ? 'hidden': ''}">
          <button class="swiper-arrow swiper-arrow--prev small-hide hidden">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
              <path d="M7 1L2 6.29412L7 11" stroke="black" stroke-width="1.5"/>
            </svg>
          </button>
          <div class="swiper">
            <div class="tabs swiper-wrapper" data-role="tablist">
              ${innerTabsHtml}
            </div>
          </div>
          <button class="swiper-arrow swiper-arrow--next small-hide hidden">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
              <path d="M0.999999 11L6 5.70588L1 0.999999" stroke="black" stroke-width="1.5"/>
            </svg>
          </button>
          </color-group-tabs>
        `;

        parentWrapper.prepend(tabs)
      }

      // bind events
      this.bindTabEvents();
    }

    bindTabEvents() {
      // Initialize Swiper for tabs
      const tabsWrapper = this.querySelector('.color-group-tabs-wrapper');
      const tabsWrapperStyleName = tabsWrapper.querySelector('.color-group__label span');
      const tabsSwiper = this.querySelector('color-group-tabs');
      const tabChangeColorChange = this.closest('associated-variant-radios')?.dataset.tabChangeColorChange;
      // const swiper = new Swiper(tabsSwiper.querySelector('.swiper'), {
      //   slidesPerView: 'auto',
      //   loop: true,
      //   spaceBetween: 0,
      //   navigation: {
      //     prevEl: tabsSwiper.querySelector('.swiper-arrow--prev'),
      //     nextEl: tabsSwiper.querySelector('.swiper-arrow--next'),
      //   }
      // });

      this.parent = this.querySelector('.color-options-wrapper');
      this.tabs = this.parent.querySelectorAll('[role="tab"]');
      this.panels = this.parent.querySelectorAll('[role="tabpanel"]');
      this.allOptions = this.parent.querySelectorAll('input[name="Color"]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          this.tabs.forEach((t) => {
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
          });
          e.target.setAttribute('aria-selected', 'true');
          e.target.setAttribute('tabindex', '0');

          const selectedId = `${e.target.getAttribute('aria-controls')}`;
          let firstVisibleColor = null;
          document.querySelector('.product--content').setAttribute('data-selected-tab', selectedId)
          this.allOptions.forEach(option => {
            const identifier = option.dataset.groupId;
            if (selectedId === "all" || identifier === selectedId) {
              option.closest('div').classList.remove('hidden');
              if(!firstVisibleColor) {
                firstVisibleColor = option;
              }
            } else {
              option.closest('div').classList.add('hidden')
            }
          });

          if(firstVisibleColor && tabChangeColorChange == 'true' && !this._initializing) {
            firstVisibleColor.checked = true;
            firstVisibleColor.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // set the selected style name
          if (tabsWrapperStyleName) {
            tabsWrapperStyleName.innerHTML = e.target.innerHTML;
          }
        });

        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const currentTab = e.target;
            let nextTab;
            if (e.key === 'ArrowRight') {
              nextTab = currentTab.nextElementSibling;
              if (!nextTab) {
                nextTab = this.tabs[0];
              }
            } else {
              nextTab = currentTab.previousElementSibling;
              if (!nextTab) {
                nextTab = this.tabs[this.tabs.length - 1];
              }
            }
            nextTab.focus();
          }
        });
      });

      // trigger the event on the selected category
      const selectedTab = this.parent.querySelector('.tab[aria-selected="true"]');
      this._initializing = true;
      selectedTab.click();
      this._initializing = false;
    }

    onVariantChange() {
      this.getSelectedOption();
      this.updateOptionLabels();
      this.updateSizeDescription();
      this.updateSelectedInfoBeforeFetchingProductInfo();
      this.renderProductInfo();
    }

    updateOptionLabels(colorValue = null) {
      const selectedColorInput = this.querySelector('input[name="Color"]:checked');
      const colorName = colorValue ?? selectedColorInput?.value;

      const legendColorEl = this.querySelector('.color-options-wrapper__legend .option-selected-value');
      if (legendColorEl && colorName) {
        legendColorEl.dataset.selectedColor = colorName;
        legendColorEl.textContent = `${colorName}`;
      }

      const selectedSizeInput = this.querySelector('input[name="Size"]:checked');
      const sizeLabels = this.querySelectorAll('.selected__size.option-selected-value');
      if (selectedSizeInput && sizeLabels.length) {
        const sizeLabelEl = selectedSizeInput.closest('.size-thumbnail-buttons__item')?.querySelector('.size-thumbnail-button__label');
        const sizeValue = sizeLabelEl?.textContent?.trim() || selectedSizeInput.value;
        sizeLabels.forEach((el) => {
          el.textContent = `${sizeValue}`;
        });
      }
    }

    updateSizeDescription() {
      const descriptionEl = this.querySelector('.size-thumbnail-buttons__description');
      if (!descriptionEl) return;

      const selectedSizeInput = this.querySelector('input[name="Size"]:checked');
      const descriptionText = selectedSizeInput?.dataset.sizeDescription?.trim();

      if (descriptionText) {
        descriptionEl.textContent = descriptionText;
        descriptionEl.classList.remove('visually-hidden');
      } else {
        descriptionEl.textContent = '';
        descriptionEl.classList.add('visually-hidden');
      }
    }

    getSelectedOption() {
      this.currentVariant = null;
      const selectedSizeInput = this.querySelector('input[name="Size"]:checked');
      const selectedColorInput = this.querySelector('input[name="Color"]:checked');
      const selectedSize = selectedSizeInput?.dataset.value || this.dataset.currentSize;
      const selectedColor = selectedColorInput?.dataset.value;

      this.options = [selectedSize, selectedColor].filter((value) => value != null);

      const selectedGroup = selectedColorInput?.dataset.group || '';
      const productsList = Array.from(this.querySelectorAll('select.product__all-options option'));
      const matched = productsList.find((option) => {
        const matchesOptions = convertTextToSlug(option.dataset.option0) === convertTextToSlug(selectedSize)
          && convertTextToSlug(option.dataset.option1) === convertTextToSlug(selectedColor);
        const matchesGroup = !selectedGroup
          || convertTextToSlug(option.dataset.swatchGroup) === convertTextToSlug(selectedGroup);
        return matchesOptions && matchesGroup;
      });

      if (!matched) return;

      this.currentVariant = {
        id: matched.dataset.variantId,
        productUrl: matched.dataset.productUrl,
        size: convertTextToSlug(matched.dataset.option0),
        featuredImage: matched.dataset.featuredImage,
        images: matched.dataset.imagesDesktop ? matched.dataset.imagesDesktop.split(',') : [],
      };
    }

    updateSelectedInfoBeforeFetchingProductInfo(){
      const selectedSwatch = this.querySelector('input[name="Color"]:checked');
      if (!selectedSwatch) return;

      const selectedGroupWrapper = selectedSwatch.closest('[data-group-name]');
      if (!selectedGroupWrapper) return;

      this._setGroupExpanded(selectedGroupWrapper, true);

      this.querySelectorAll('[data-group-name]').forEach((group) => {
        if (group !== selectedGroupWrapper) {
          this._setGroupExpanded(group, false);
        }
      });

      const selectedColorLabel = selectedGroupWrapper.querySelector('.color-group__label');
      const selectedColorParagraph = selectedColorLabel?.querySelector('p');
      if (selectedColorParagraph) {
        selectedColorParagraph.querySelector('span')?.remove();
        selectedColorParagraph.textContent = selectedColorParagraph.textContent.trim();
        selectedColorParagraph.insertAdjacentHTML(
          'beforeend',
          `<span class="selected__color" data-selected-color="${selectedSwatch.value}"><span>&nbsp;|&nbsp;</span>${selectedSwatch.value}</span>`,
        );
      }

      // Show low-res images immediately in visible gallery
      if (window.theme?.enableLowResImageLoading) {
        const mediaGallery = this.closest('.product--content').querySelector('media-gallery');

        if (mediaGallery && this.currentVariant?.images) {
          // Update visible gallery with optimized preview (low-res or cached high-res)
          this.showLowResPreview(mediaGallery);
        }
      }
    }

    async showLowResPreview(mediaGallery) {
      // Exit early if low-res image loading is disabled
      if (!window.theme?.enableLowResImageLoading) {
        return;
      }

      const pictureElements = mediaGallery.querySelectorAll('picture');

      // Update available images (now with async cache checking)
      const updatePromises = this.currentVariant.images.map((imageUrl, index) => {
        if (pictureElements[index]) {
          return this.updatePictureToLowRes(pictureElements[index], imageUrl);
        }
        return Promise.resolve();
      });

      await Promise.all(updatePromises);

      // Handle extra picture elements that don't have corresponding images
      // Use the last available image or first image as fallback
      if (pictureElements.length > this.currentVariant.images.length) {
        const fallbackImageUrl = this.currentVariant.images[this.currentVariant.images.length - 1] || this.currentVariant.images[0];

        const fallbackPromises = [];
        for (let i = this.currentVariant.images.length; i < pictureElements.length; i++) {
          if (fallbackImageUrl && pictureElements[i]) {
            fallbackPromises.push(this.updatePictureToLowRes(pictureElements[i], fallbackImageUrl));
          }
        }

        await Promise.all(fallbackPromises);
      }
    }

    async updatePictureToLowRes(pictureElement, imageUrl) {
      // Exit early if low-res image loading is disabled
      if (!window.theme?.enableLowResImageLoading) {
        return;
      }

      const mobileSource = pictureElement.querySelector('source[media*="max-width"]');
      const desktopSource = pictureElement.querySelector('source[media*="min-width"]');
      const fallbackImg = pictureElement.querySelector('img');

      // Check if high-res image is already available/cached
      const isHighResCached = await this.isImageCached(imageUrl);

      if (isHighResCached) {

        if (mobileSource) {
          mobileSource.srcset = this.generateHighResSrcset(imageUrl, [375, 750, 1100]);
        }
        if (desktopSource) {
          desktopSource.srcset = this.generateHighResSrcset(imageUrl, [750, 1100, 1500]);
        }
        if (fallbackImg) {
          fallbackImg.src = imageUrl; // Use full resolution
        }

        // Don't add progressive-loading class since we're using high-res
        pictureElement.classList.remove('progressive-loading');

      } else {
        // Use low-res first as normal
        if (mobileSource) {
          mobileSource.srcset = this.generateLowResSrcset(imageUrl, [50, 75, 100, 125, 150]);
        }
        if (desktopSource) {
          desktopSource.srcset = this.generateLowResSrcset(imageUrl, [100, 150, 200]);
        }
        if (fallbackImg) {
          fallbackImg.src = imageUrl.replace(/width=\d+/, 'width=100');
        }

        // Add loading class for potential CSS styling
        pictureElement.classList.add('progressive-loading');
      }
    }

    generateLowResSrcset(baseUrl, widths) {
      return widths.map(width => {
        const url = baseUrl.replace(/width=\d+/, `width=${width}`);
        return `${url} ${width}w`;
      }).join(', ');
    }

    generateHighResSrcset(baseUrl, widths) {
      return widths.map(width => {
        const url = baseUrl.replace(/width=\d+/, `width=${width}`);
        return `${url} ${width}w`;
      }).join(', ');
    }

    async isImageCached(imageUrl) {
      return new Promise((resolve) => {
        const img = new Image();

        // Set a very short timeout for cache check
        const timeout = setTimeout(() => {
          resolve(false);
        }, 50); // 50ms timeout for cache check

        img.onload = () => {
          clearTimeout(timeout);
          // If it loads very quickly, it's likely cached
          resolve(true);
        };

        img.onerror = () => {
          clearTimeout(timeout);
          resolve(false);
        };

        // Start loading the image - if cached, this should be very fast
        img.src = imageUrl;
      });
    }

    _swapElementInnerHtml(destination, source) {
      if (destination && source) {
        destination.innerHTML = source.innerHTML;
      }
    }

    preserveBitsAddonModal() {
      const bitsModal = document.querySelector('bits-addon-modal');
      if (!bitsModal) return null;

      if (bitsModal.classList.contains('bits-addon-modal--open')) {
        bitsModal.setAttribute('data-updating', '');
      }

      if (bitsModal.parentElement !== document.body) {
        document.body.appendChild(bitsModal);
      }

      return bitsModal;
    }

    finalizeBitsAddonModalAfterSwap(sectionElement, bitsModal) {
      if (sectionElement) {
        sectionElement
          .querySelectorAll('.product__info-wrapper bits-addon-modal')
          .forEach((el) => el.remove());
      }

      if (!bitsModal) return;

      if (bitsModal.parentElement !== document.body) {
        document.body.appendChild(bitsModal);
      }

      if (this.currentVariant?.id) {
        bitsModal.dataset.productId = this.currentVariant.id;
      }

      const clearUpdating = () => bitsModal.removeAttribute('data-updating');
      if (bitsModal.classList.contains('bits-addon-modal--open')) {
        requestAnimationFrame(() => requestAnimationFrame(clearUpdating));
      } else {
        clearUpdating();
      }
    }

    _toggleVisibilityFromSource(destination, source) {
      if (destination && source) {
        destination.classList.toggle('visibility-hidden', source.classList.contains('visibility-hidden'));
      }
    }

    _updatePdpUpsells(sectionElement, sourceRoot) {
      const pdpUpsellsDestination = sectionElement.querySelector('.pdp-upsells');
      const pdpUpsellsSource = sourceRoot.querySelector('.pdp-upsells');

      if (pdpUpsellsSource) {
        // importNode so <bits-addon-trigger-block> upgrades; a cloneNode stays inert.
        const refreshedUpsells = document.importNode(pdpUpsellsSource, true);

        if (pdpUpsellsDestination) {
          pdpUpsellsDestination.replaceWith(refreshedUpsells);
          return;
        }

        const productInfo = sectionElement.querySelector('product-info');
        const insertBefore = productInfo?.querySelector('.product__view-details');

        if (insertBefore) {
          insertBefore.insertAdjacentElement('beforebegin', refreshedUpsells);
        } else {
          productInfo?.appendChild(refreshedUpsells);
        }

        return;
      }

      pdpUpsellsDestination?.remove();
    }

    /**
     * Replaces the colour-dependent regions that `updateVariantDependentInfo()` does not patch.
     *
     * Scoped to `product-info` to skip the `.product__title-price` that `renderProductInfo()`
     * already swaps inside `.product__info-mobile`. Regions pair by document order; a count
     * mismatch skips that selector. Do not read layout in the loop.
     *
     * @param {HTMLElement} productInfo - The live `product-info` element.
     * @param {Document|HTMLElement} sourceRoot - The freshly rendered section markup.
     */
    _updateVariantScopedRegions(productInfo, sourceRoot) {
      const sourceInfo = sourceRoot.querySelector('product-info');
      if (!sourceInfo) return;

      // Divvy last: its `refresh()` writes the mode price into `.product__title-price`. Matched on
      // the wrapper, which the section always emits, so the element inside can come and go.
      const selectors = [
        '.product__title-price',
        '.size-thumbnail-buttons-wrapper:not(.divvy-set__modes)',
        '.size-options-wrapper',
        'sizes-dropdown',
        'modal-stock-notify',
        '.product-form__wrapper--divvy-set',
      ];

      for (const selector of selectors) {
        const destinations = Array.from(productInfo.querySelectorAll(selector));
        if (destinations.length === 0) continue;

        const sources = Array.from(sourceInfo.querySelectorAll(selector));
        if (destinations.length !== sources.length) continue;

        destinations.forEach((destination, index) => {
          // importNode, not cloneNode: DOMParser nodes carry no registry, so clones never upgrade.
          const replacement = document.importNode(sources[index], true);

          // An imported <script> re-executes on insert. divvy-set.js calls customElements.define()
          // unguarded, so it would throw and refetch on every colour change.
          for (const script of replacement.querySelectorAll('script')) script.remove();

          destination.replaceWith(replacement);
        });
      }

      // divvy-set-selector hides the standard buy button in set mode. A colour with no set renders
      // no selector, so nothing restores it. Clear the class it left behind.
      if (!productInfo.querySelector('divvy-set-selector')) {
        productInfo
          .querySelector('product-form')
          ?.closest('.product-form__wrapper')
          ?.classList.remove('hidden');
      }

      this.updateOptionLabels();
      this.updateSizeDescription();
    }

    updateVariantDependentInfo(sectionElement, sectionRoot, sectionId) {
      const productInfo = sectionElement.querySelector('product-info');
      if (!productInfo) return;

      const sourceRoot = sectionRoot.querySelector(`#shopify-section-${sectionId}`) || sectionRoot;

      this._swapElementInnerHtml(
        sectionElement.querySelector(`#price-${sectionId}`),
        sourceRoot.querySelector(`#price-${sectionId}`),
      );

      this._swapElementInnerHtml(
        sectionElement.querySelector(`#Inventory-${sectionId}`),
        sourceRoot.querySelector(`#Inventory-${sectionId}`),
      );

      this._swapElementInnerHtml(
        sectionElement.querySelector(`#Sku-${sectionId}`),
        sourceRoot.querySelector(`#Sku-${sectionId}`),
      );

      this._swapElementInnerHtml(
        sectionElement.querySelector(`#Volume-${sectionId}`),
        sourceRoot.querySelector(`#Volume-${sectionId}`),
      );

      const pricePerItemDestination = sectionElement.querySelector(`#Price-Per-Item-${sectionId}`);
      const pricePerItemSource = sourceRoot.querySelector(`#Price-Per-Item-${sectionId}`);
      this._swapElementInnerHtml(pricePerItemDestination, pricePerItemSource);
      this._toggleVisibilityFromSource(pricePerItemDestination, pricePerItemSource);

      const priceEl = sectionElement.querySelector(`#price-${sectionId}`);
      if (priceEl) {
        priceEl.classList.remove('visibility-hidden');
      }

      const productFormId = `product-form-${sectionId}`;
      const destinationForm = document.getElementById(productFormId);
      const sourceForm = sourceRoot.querySelector(`#${productFormId}`);

      if (destinationForm && sourceForm) {
        const destinationInput = destinationForm.querySelector('[name="id"]');
        const sourceInput = sourceForm.querySelector('[name="id"]');

        if (destinationInput && sourceInput) {
          destinationInput.value = sourceInput.value;
          destinationInput.disabled = sourceInput.disabled;
        }

        // Replace the entire buttons subtree with the freshly-rendered source markup.
        //
        // We can't surgically patch the add button here because the pre-order app
        // (PreProduct / "pp") rewrites this region on pre-order products: it clones the
        // native submit button (tagging the clone with `data-native-pre-order-btn-added`),
        // hides both native buttons with inline styles, and injects its own widget
        // (`#pp-native-btn-area`). Copying individual attributes leaves all of that behind,
        // so switching pre-order -> non-pre-order left two hidden add buttons and no
        // clickable "Add to Bag". Swapping the whole subtree wipes the app's leftovers and
        // restores the clean server-rendered buttons (notify + add) for the target product.
        // The app is re-triggered via window.PPretry() later in renderProductInfo(), which
        // re-injects its widget only when the new product is actually pre-order.
        const destinationButtons = destinationForm.querySelector('.product-form__buttons');
        const sourceButtons = sourceForm.querySelector('.product-form__buttons');
        if (destinationButtons && sourceButtons) {
          destinationButtons.innerHTML = sourceButtons.innerHTML;
        }

        destinationForm.classList.toggle(
          'product__not-available',
          sourceForm.classList.contains('product__not-available'),
        );
      }

      const installmentDestination = document.getElementById(`product-form-installment-${sectionId}`);
      const installmentSource = sourceRoot.querySelector(`#product-form-installment-${sectionId}`);
      this._swapElementInnerHtml(installmentDestination, installmentSource);

      const selectedColorSource = sourceRoot.querySelector('.selected__color');
      const selectedColorDestination = this.querySelector(`#variant-radios-${sectionId} .selected__color`);
      if (selectedColorSource && selectedColorDestination) {
        selectedColorDestination.innerHTML = selectedColorSource.innerHTML;
      }

      this._updatePdpUpsells(sectionElement, sourceRoot);

      // Last: `divvy-set-selector`'s `refresh()` writes into the buy buttons swapped above.
      this._updateVariantScopedRegions(productInfo, sourceRoot);
    }

    renderProductInfo() {
      const productInfoWrapper = this.closest('product-info');
      const productForm = productInfoWrapper?.querySelector('product-form');
      const sectionsToFetchAndRender = [];

      if (document.querySelector('.main-product-info-section')) {
        sectionsToFetchAndRender.push(
          document.querySelector('.main-product-info-section').getAttribute('id').replace('shopify-section-', ''),
        );
      }

      if (document.querySelector('.cross-sell-products-section')) {
        sectionsToFetchAndRender.push(
          document.querySelector('.cross-sell-products-section').getAttribute('id').replace('shopify-section-', ''),
        );
      }

      if (!this.currentVariant) {
        productForm?.classList.add('product__not-available');
        productForm?.querySelector('[name="id"]')?.setAttribute('disabled', 'disabled');
        return;
      }

      productForm?.classList.remove('product__not-available');

      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

      window.history.replaceState({}, '', `${this.currentVariant.productUrl}?variant=${requestedVariantId}`);
      this.updateMetaTags();

      const preservedBitsModal = this.preserveBitsAddonModal();

      this.fetchAbortController?.abort();
      this.fetchAbortController = new AbortController();

      fetch(
        `${this.currentVariant.productUrl}?variant=${requestedVariantId}&sections=${sectionsToFetchAndRender.join(',')}`,
        { signal: this.fetchAbortController.signal },
      )
        .then((response) => response.json())
        .then(async (responseJson) => {
          const modalIsOpen = preservedBitsModal?.classList.contains('bits-addon-modal--open');
          if (!modalIsOpen) {
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('bits-addon-modal-open');
          }
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant?.id !== requestedVariantId) return;

          for (const section of sectionsToFetchAndRender) {
            const sectionElement = document.getElementById(`shopify-section-${section}`);
            if (!sectionElement) continue;

            const html = new DOMParser().parseFromString(responseJson[section], 'text/html');

            if (sectionElement.classList.contains('main-product-info-section')) {
              if (preservedBitsModal) {
                if (preservedBitsModal.parentElement !== document.body) {
                  document.body.appendChild(preservedBitsModal);
                }
                if (preservedBitsModal.classList.contains('bits-addon-modal--open')) {
                  preservedBitsModal.setAttribute('data-updating', '');
                }
              }

              this.updateVariantDependentInfo(sectionElement, html, sectionId);

              this.finalizeBitsAddonModalAfterSwap(sectionElement, preservedBitsModal);

              const sectionRoot = html.querySelector(`#shopify-section-${section}`) || html;
              const productModalContent = document.querySelector('product-modal .product-media-modal__content');
              const sourceModalContent = sectionRoot.querySelector('product-modal .product-media-modal__content');

              if (productModalContent && sourceModalContent) {
                productModalContent.innerHTML = sourceModalContent.innerHTML;
              }

              const existingWishlistButtons = sectionElement.querySelectorAll('wishlist-button-product');
              existingWishlistButtons.forEach((wishlistButton) => wishlistButton.remove());
              sectionElement.querySelector('.product__media-wrapper .product__wishlist-icon')?.remove();

              const wishlistIcon = document.createElement('span');
              wishlistIcon.className = 'product__wishlist-icon';
              sectionElement
                .querySelector('.product__media-wrapper .product__media-wrapper-inner')
                ?.appendChild(wishlistIcon);

              const productInfoMobile = sectionElement.querySelector('.product__info-mobile');
              const sourceProductInfoMobile = sectionRoot.querySelector('.product__info-mobile');
              this._swapElementInnerHtml(productInfoMobile, sourceProductInfoMobile);

              const mediaInnerComponents = sectionElement.querySelector('.product__media-inner-components');
              const sourceMediaInnerComponents = sectionRoot.querySelector('.product__media-inner-components');
              this._swapElementInnerHtml(mediaInnerComponents, sourceMediaInnerComponents);

              // updating the product media gallery section(s) — mobile and desktop wrappers
              const currentMediaWrappers = sectionElement.querySelectorAll('.product__media-wrapper');
              const newMediaWrappers = sectionRoot.querySelectorAll('.product__media-wrapper');

              for (let i = 0; i < currentMediaWrappers.length; i++) {
                if (newMediaWrappers[i]) {
                  await this.updateGalleryOptimized(currentMediaWrappers[i], newMediaWrappers[i]);
                }
              }

              publish(PUB_SUB_EVENTS.variantChange, {
                data: {
                  sectionId,
                  html,
                  variant: this.currentVariant,
                  variantId: requestedVariantId,
                },
              });
            } else {
              const sectionRoot = html.querySelector(`#shopify-section-${section}`) || html;
              sectionElement.innerHTML = sectionRoot.innerHTML;
            }
          }

          window.updateShopifyInstallmentText();

          if (window.shipscoutInit) window.shipscoutInit();
          if (window.yotpoWidgetsContainer) yotpoWidgetsContainer.initWidgets();
          if (window.PPretry) window.PPretry();
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.error('Error fetching product info:', error);
        });
    }

    async updateGalleryOptimized(currentSection, newSectionHtml) {
      const currentGallery = currentSection.querySelector('media-gallery');
      const newGallery = newSectionHtml.querySelector('media-gallery');

      if (!currentGallery || !newGallery) {
        currentSection.innerHTML = newSectionHtml.innerHTML;
        return;
      }

      const currentSwiperWrapper = currentGallery.querySelector('swiper-main-product .swiper');
      const newSwiperWrapper = newGallery.querySelector('swiper-main-product .swiper');

      if (!currentSwiperWrapper || !newSwiperWrapper) {
        currentSection.innerHTML = newSectionHtml.innerHTML;
        return;
      }

      // Update slides intelligently
      await this.updateGallerySlides(currentSwiperWrapper, newSwiperWrapper);

      this.updateGalleryThumbnails(currentGallery, newGallery);

      // Update gallery status and other elements
      const currentStatus = currentGallery.querySelector('[id^="GalleryStatus"]');
      const newStatus = newGallery.querySelector('[id^="GalleryStatus"]');

      if (currentStatus && newStatus) {
        currentStatus.innerHTML = newStatus.innerHTML;
      }

      const currentBadgeContainer = currentGallery.querySelector('.product__media-gallery-badges');
      const newBadgeContainer = newGallery.querySelector('.product__media-gallery-badges');
      const currentViewer = currentGallery.querySelector('swiper-main-product');

      if (currentBadgeContainer && newBadgeContainer) {
        currentBadgeContainer.innerHTML = newBadgeContainer.innerHTML;
      } else if (currentViewer && newBadgeContainer) {
        currentViewer.insertAdjacentElement('afterbegin', newBadgeContainer.cloneNode(true));
      } else if (currentBadgeContainer) {
        currentBadgeContainer.remove();
      }

      // Update any other gallery-related elements
      const otherElements = newGallery.querySelectorAll(':not([id^="GalleryViewer"]):not([id^="GalleryThumbnails"]):not([id^="GalleryStatus"])');
      otherElements.forEach(element => {
        const currentElement = currentGallery.querySelector(`[id="${CSS.escape(element.id)}"]`);
        if (currentElement) {
          currentElement.innerHTML = element.innerHTML;
        }
      });

      // Trigger gallery update event for any listeners
      currentGallery.dispatchEvent(new CustomEvent('galleryUpdated', {
        detail: {
          variant: this.currentVariant,
          thumbnailsSynced: true,
        },
      }));
    }

    updateGalleryThumbnails(currentGallery, newGallery) {
      const syncedActiveColor = newGallery.getAttribute('data-active-color');
      const colorOptionIndex = newGallery.getAttribute('data-color-option-index');
      const hasVariantImages = newGallery.getAttribute('data-has-variant-images');

      if (syncedActiveColor) {
        currentGallery.setAttribute('data-active-color', syncedActiveColor);
      } else {
        currentGallery.removeAttribute('data-active-color');
      }

      if (colorOptionIndex !== null) {
        currentGallery.setAttribute('data-color-option-index', colorOptionIndex);
      }

      if (hasVariantImages) {
        currentGallery.setAttribute('data-has-variant-images', hasVariantImages);
      } else {
        currentGallery.removeAttribute('data-has-variant-images');
      }

      const currentThumbList = currentGallery.querySelector('[id^="Slider-Thumbnails"]');
      const newThumbList = newGallery.querySelector('[id^="Slider-Thumbnails"]');

      if (currentThumbList && newThumbList) {
        currentThumbList.innerHTML = newThumbList.innerHTML;
      }

      const sliderComponent = currentGallery.querySelector('slider-component');
      if (sliderComponent?.resetPages) {
        sliderComponent.resetPages();
      }

      // Do not overwrite data-active-color with the swatch slug here.
      // The section fetch renders the same Liquid as a full page load; injecting a
      // client-side slug enables filtering that never ran on initial load and re-hides thumbs.
    }

    async updateGallerySlides(currentSwiperWrapper, newSwiperWrapper) {
      const currentSwiper = currentSwiperWrapper.swiper;
      const currentSlides = currentSwiperWrapper.querySelectorAll('.swiper-slide');
      const newSlides = newSwiperWrapper.querySelectorAll('.swiper-slide');
      const swiperWrapper = currentSwiperWrapper.querySelector('.swiper-wrapper');

      // Store current active slide index
      const currentActiveIndex = currentSwiper ? currentSwiper.activeIndex : 0;
      const currentSlideCount = currentSlides.length;
      const newSlideCount = newSlides.length;

      // Minimize Swiper interference during updates
      let originalTransitionDuration = null;
      if (currentSwiper && currentSwiper.params) {
        originalTransitionDuration = currentSwiper.params.speed;
        currentSwiper.params.speed = 0;
      }

      try {
        // Images will load automatically when innerHTML is replaced - no preloading needed!

        // Handle slide count differences (batch DOM operations)
        if (newSlideCount > currentSlideCount) {
          // Create document fragment for efficient DOM manipulation
          const fragment = document.createDocumentFragment();
          for (let i = currentSlideCount; i < newSlideCount; i++) {
            const newSlideClone = newSlides[i].cloneNode(true);
            const newPicture = newSlideClone.querySelector('picture');
            if (newPicture) {
              newPicture.classList.remove('progressive-loading');
            }
            fragment.appendChild(newSlideClone);
          }
          swiperWrapper.appendChild(fragment);
        } else if (currentSlideCount > newSlideCount) {
          // Remove extra slides in reverse order (more efficient)
          const slidesToRemove = Array.from(currentSlides).slice(newSlideCount);
          slidesToRemove.forEach(slide => slide.remove());
        }

        // Update existing slides in parallel (much faster)
        const minSlideCount = Math.min(currentSlideCount, newSlideCount);
        const updatePromises = [];

        for (let i = 0; i < minSlideCount; i++) {
          const currentSlide = currentSlides[i];
          const newSlide = newSlides[i];

          if (currentSlide && newSlide) {
            // Process slides in parallel without artificial delays
            updatePromises.push(this.updateSingleSlide(currentSlide, newSlide));
          }
        }

        // Wait for all slide updates to complete
        await Promise.all(updatePromises);

        // Ensure slide attributes stay in sync with fetched HTML
        const updatedSlides = currentSwiperWrapper.querySelectorAll('.swiper-slide');
        const minSyncCount = Math.min(updatedSlides.length, newSlides.length);
        for (let i = 0; i < minSyncCount; i++) {
          if (updatedSlides[i] && newSlides[i]) {
            this.updateSlideAttributes(updatedSlides[i], newSlides[i]);
          }
        }

        // Update swiper efficiently
        if (currentSwiper) {
          currentSwiper.update();

          // Restore transition speed immediately (no artificial delay)
          if (originalTransitionDuration !== null) {
            currentSwiper.params.speed = originalTransitionDuration;
          }

          // Go to first slide quickly
          currentSwiper.slideTo(0, 100);

          // Update pagination if it exists
          if (currentSwiper.pagination && currentSwiper.pagination.el) {
            currentSwiper.pagination.update();
          }
        }

      } catch (error) {
        console.error('Error in optimized gallery update, using fallback:', error);

        // Restore Swiper state
        if (currentSwiper && originalTransitionDuration !== null) {
          currentSwiper.params.speed = originalTransitionDuration;
        }

        // Fast fallback method
        const minSlideCount = Math.min(currentSlideCount, newSlideCount);
        for (let i = 0; i < minSlideCount; i++) {
          const currentSlide = currentSlides[i];
          const newSlide = newSlides[i];

          if (currentSlide && newSlide) {
            this.updateSlideAttributes(currentSlide, newSlide);
          }
        }
      }
    }

    // Optimized helper methods for faster gallery updates
    async updateSingleSlide(currentSlide, newSlide) {
      try {
        const currentPicture = currentSlide.querySelector('picture');
        const newPicture = newSlide.querySelector('picture');

        if (currentPicture && newPicture) {
          // Smooth image transition without flash
          await this.updateImageSmoothly(currentPicture, newPicture);
        } else {
          // Fallback to full slide replacement
          currentSlide.innerHTML = newSlide.innerHTML;
        }

        // Update attributes efficiently
        this.updateSlideAttributes(currentSlide, newSlide);
        return true;
      } catch (error) {
        currentSlide.innerHTML = newSlide.innerHTML;
        this.updateSlideAttributes(currentSlide, newSlide);
        return false;
      }
    }

    async updateImageSmoothly(currentPicture, newPicture) {
      // Get the main img element to check if we need to preload
      const currentImg = currentPicture.querySelector('img');
      const newImg = newPicture.querySelector('img');

      if (!currentImg || !newImg) {
        // No main image found, fallback to direct replacement
        currentPicture.innerHTML = newPicture.innerHTML;
        return;
      }

      // Check if it's the same image (no need to update)
      if (currentImg.src === newImg.src) {
        return;
      }

      // Preload the new image to prevent flash
      const imageReady = await this.preloadImage(newImg.src);

      if (imageReady) {
        // Set up smooth transition
        currentPicture.style.transition = 'opacity 0.15s ease-in-out';

        // Fade out briefly
        currentPicture.style.opacity = '0.7';

        // Wait a moment for the fade
        await new Promise(resolve => setTimeout(resolve, 75));

        // Update the image sources now that new image is loaded
        const sources = currentPicture.querySelectorAll('source');
        const newSources = newPicture.querySelectorAll('source');

        // Update srcsets for responsive images
        sources.forEach((source, index) => {
          if (newSources[index]) {
            source.srcset = newSources[index].srcset;
          }
        });

        // Update main img src and attributes
        currentImg.src = newImg.src;
        if (newImg.alt) currentImg.alt = newImg.alt;
        if (newImg.width) currentImg.width = newImg.width;
        if (newImg.height) currentImg.height = newImg.height;

        // Fade back in
        currentPicture.style.opacity = '1';

        // Clean up transition after animation
        setTimeout(() => {
          currentPicture.style.transition = '';
          currentPicture.style.opacity = '';
        }, 150);
      } else {
        // If preload failed, fallback to direct replacement
        currentPicture.innerHTML = newPicture.innerHTML;
      }
    }

    async preloadImage(src) {
      return new Promise((resolve) => {
        const img = new Image();

        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          resolve(false);
        }, 1000); // 1 second timeout

        img.onload = () => {
          clearTimeout(timeout);
          resolve(true);
        };

        img.onerror = () => {
          clearTimeout(timeout);
          resolve(false);
        };

        img.src = src;
      });
    }

    updateSlideAttributes(currentSlide, newSlide) {
      // Batch attribute updates for efficiency
      if (newSlide.dataset.mediaId) {
        currentSlide.dataset.mediaId = newSlide.dataset.mediaId;
      }
      if (newSlide.dataset.color) {
        currentSlide.dataset.color = newSlide.dataset.color;
      }

      // Preserve progressive loading state
      const hadProgressiveLoading = currentSlide.classList.contains('progressive-loading');
      currentSlide.className = newSlide.className;
      if (hadProgressiveLoading) {
        currentSlide.classList.remove('progressive-loading');
      }
    }

    async updateSlideImagesSmoothly(currentSlide, newSlide) {
      const currentPicture = currentSlide.querySelector('picture');
      const newPicture = newSlide.querySelector('picture');

      if (!currentPicture || !newPicture) {
        // Fallback to innerHTML replacement if picture elements not found
        currentSlide.innerHTML = newSlide.innerHTML;
        return false;
      }

      // Add smooth transition class
      currentPicture.style.transition = 'opacity 0.2s ease-in-out';

      try {
        // Ensure the new image is fully loaded before updating srcsets
        await this.preloadSlideImage(newSlide);

        // Small delay to ensure smooth visual transition
        await new Promise(resolve => setTimeout(resolve, 50));

        // Update picture sources smoothly
        const mobileSource = currentPicture.querySelector('source[media*="max-width"]');
        const desktopSource = currentPicture.querySelector('source[media*="min-width"]');
        const fallbackImg = currentPicture.querySelector('img');

        const newMobileSource = newPicture.querySelector('source[media*="max-width"]');
        const newDesktopSource = newPicture.querySelector('source[media*="min-width"]');
        const newFallbackImg = newPicture.querySelector('img');

        // Update srcsets and img sources (image should be cached now)
        if (mobileSource && newMobileSource) {
          mobileSource.srcset = newMobileSource.srcset;
        }
        if (desktopSource && newDesktopSource) {
          desktopSource.srcset = newDesktopSource.srcset;
        }
        if (fallbackImg && newFallbackImg) {
          fallbackImg.src = newFallbackImg.src;
          fallbackImg.alt = newFallbackImg.alt;
          fallbackImg.width = newFallbackImg.width;
          fallbackImg.height = newFallbackImg.height;
          fallbackImg.sizes = newFallbackImg.sizes;
          fallbackImg.fetchpriority = newFallbackImg.fetchpriority;
          fallbackImg.loading = newFallbackImg.loading;

          // Update classes
          fallbackImg.className = newFallbackImg.className;
        }

        // Remove progressive loading class as we now have high-res
        currentPicture.classList.remove('progressive-loading');

        // Update any other slide attributes outside the picture
        const currentVideoHandler = currentSlide.querySelector('video-handler');
        const newVideoHandler = newSlide.querySelector('video-handler');

        if (newVideoHandler && !currentVideoHandler) {
          // Add video handler if new slide has one
          currentSlide.appendChild(newVideoHandler.cloneNode(true));
        } else if (!newVideoHandler && currentVideoHandler) {
          // Remove video handler if new slide doesn't have one
          currentVideoHandler.remove();
        } else if (currentVideoHandler && newVideoHandler) {
          // Update video handler content
          currentVideoHandler.innerHTML = newVideoHandler.innerHTML;
        }

        // Clean up transition after a delay
        setTimeout(() => {
          if (currentPicture.style) {
            currentPicture.style.transition = '';
          }
        }, 300);

        return true;

      } catch (error) {
        console.error('Error in smooth slide update:', error);
        // Remove transition style on error
        if (currentPicture.style) {
          currentPicture.style.transition = '';
        }
        return false;
      }
    }

    preloadSlideImage(newSlide) {
      return new Promise((resolve) => {
        const newPicture = newSlide.querySelector('picture');
        const newImg = newPicture?.querySelector('img');

        if (!newImg) {
          resolve();
          return;
        }

        const preloadImg = new Image();
        preloadImg.onload = () => resolve();
        preloadImg.onerror = () => resolve(); // Still resolve to continue
        preloadImg.src = newImg.src;
      });
    }

    updateMetaTags() {
      if (!this.currentVariant) {
        return;
      }

      try {
        const variant = this.currentVariant;
        const variantData = document.querySelector(`.product__all-options option[data-variant-id="${variant.id}"]`);

        if (!variantData) {
          return;
        }

        const variantDataTitle = variantData.dataset.productTitle;
        const variantDataDescription = variantData.dataset.productDescription;

        // Update page title
        const titleElement = document.querySelector('title');
        if (titleElement && variantDataTitle) {
          const shopName = window.Shopify?.shop || '';
          titleElement.textContent = `${variantDataTitle}${shopName ? ` – ${shopName}` : ''}`;
        }

        // Update meta description
        const descriptionMeta = document.querySelector('meta[name="description"]');
        if (descriptionMeta && variantDataDescription) {
          descriptionMeta.setAttribute('content', variantDataDescription);
        }

        // Update Open Graph tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle && variantDataTitle) {
          ogTitle.setAttribute('content', variantDataTitle);
        }

        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription && variantDataDescription) {
          ogDescription.setAttribute('content', variantDataDescription);
        }

        const ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl) {
          ogUrl.setAttribute('content', `${window.location.origin}${variantData.dataset.productUrl}`);
        }

        // Update Open Graph image if variant has a featured image
        if (variantData.dataset.featuredImage) {
          const ogImage = document.querySelector('meta[property="og:image"]');
          const ogImageSecure = document.querySelector('meta[property="og:image:secure_url"]');
          const ogImageWidth = document.querySelector('meta[property="og:image:width"]');
          const ogImageHeight = document.querySelector('meta[property="og:image:height"]');

          if (ogImage) {
            ogImage.setAttribute('content', `http:${variantData.dataset.featuredImage}`);
          }
          if (ogImageSecure) {
            ogImageSecure.setAttribute('content', `https:${variantData.dataset.featuredImage}`);
          }
          if (ogImageWidth && variantData.dataset.featuredImageWidth) {
            ogImageWidth.setAttribute('content', variantData.dataset.featuredImageWidth);
          }
          if (ogImageHeight && variantData.dataset.featuredImageHeight) {
            ogImageHeight.setAttribute('content', variantData.dataset.featuredImageHeight);
          }
        }

        // Update Open Graph price
        const ogPriceAmount = document.querySelector('meta[property="og:price:amount"]');
        const ogPriceCurrency = document.querySelector('meta[property="og:price:currency"]');

        if (ogPriceAmount && variantData.dataset.price) {
          // Convert price to format without currency symbol
          const price = (variantData.dataset.price / 100).toFixed(2);
          ogPriceAmount.setAttribute('content', price);
        }

        if (ogPriceCurrency && window.Shopify?.currency?.iso_code) {
          ogPriceCurrency.setAttribute('content', window.Shopify.currency.iso_code);
        }

        // Update Twitter Card tags
        const twitterTitle = document.querySelector('meta[name="twitter:title"]');
        if (twitterTitle && variantDataTitle) {
          twitterTitle.setAttribute('content', variantDataTitle);
        }

        const twitterDescription = document.querySelector('meta[name="twitter:description"]');
        if (twitterDescription && variantDataDescription) {
          twitterDescription.setAttribute('content', variantDataDescription);
        }

        // Update canonical URL
        const canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
          canonicalLink.setAttribute('href', `${window.location.origin}${variantData.dataset.productUrl}`);
        }
      } catch (error) {
        console.error('Error updating meta tags:', error);
      }
    }

    manageOutOfStockStatus() {
      this.getSelectedOption();

      const allColors = this.querySelectorAll('input[name="Color"]');
      const allProductOptions = this.querySelector('select.product__all-options');
      if (!allProductOptions || !this.currentVariant) return;

      allColors.forEach((color) => {
        color.classList.remove('out-of-stock', 'not__available');
        const nextLabel = color.nextElementSibling;
        nextLabel?.querySelector('.out-of-stock__icon')?.remove();
        nextLabel?.querySelector('.sr-only')?.remove();

        const groupSlug = color.dataset.group;
        const groupSelector = groupSlug ? `[data-swatch-group="${groupSlug}"]` : '';
        const thisOption = allProductOptions.querySelector(
          `option[data-option0="${convertTextToSlug(this.currentVariant.size)}"][data-option1="${convertTextToSlug(color.value)}"]${groupSelector}`,
        );

        if (thisOption) {
          if (thisOption.dataset.availability === 'false') {
            color.classList.add('out-of-stock');
            const outofStockSpan = document.createElement('span');
            outofStockSpan.classList.add('out-of-stock__icon');
            nextLabel?.appendChild(outofStockSpan);

            const srSpan = document.createElement('span');
            srSpan.textContent = 'Out of stock';
            srSpan.classList.add('sr-only');
            nextLabel?.appendChild(srSpan);
          }
        } else {
          color.classList.add('out-of-stock', 'not__available');
        }
      });
    }
  }

  customElements.define('associated-variant-radios', AssociatedVariantRadios);
}

if(!customElements.get('product-featured-image')) {
  class ProductFeaturedImage extends HTMLElement {
    constructor() {
      super();
      this.isProductPage = document.body.classList.contains('template-product');


      const featuredImageEl = document.querySelectorAll('swiper-main-product .product__media-list .product__media-item')[0];
      const imageUrl = featuredImageEl.querySelector('img').src.split('?')[0];

      this.innerHTML = `<img src="${imageUrl}" alt="" width="" height="" />`;
    }
  }

  customElements.define('product-featured-image', ProductFeaturedImage);
}


// adding css to shopify payment terms widget
window.updateShopifyInstallmentText = function() {
  const shopifyPaymentTermsEl = document.querySelector('shopify-payment-terms');

  setTimeout(function() {
    if (shopifyPaymentTermsEl && shopifyPaymentTermsEl.shadowRoot) {
      const style = document.createElement('style');
      const contentContainer = shopifyPaymentTermsEl.shadowRoot.querySelector('#shopify-installments-content');

      style.textContent = `
        .text-purple-primary {
          color: #000000 !important;
        }
      `;
      shopifyPaymentTermsEl.shadowRoot.appendChild(style);
    }
  }, 500)
};

window.updateShopifyInstallmentText();

// bits addon scripts
if(!customElements.get('bits-addon-trigger-block')) {
  class BitsAddonTriggerBlock extends HTMLElement {
    constructor() {
      super();

      this.triggerButtons = document.querySelectorAll('[data-open-bits-modal]');
    }

    connectedCallback() {
      this.triggerButtons.forEach(button => {
        button.addEventListener('click', function() {
          const modal = document.querySelector('bits-addon-modal');
          if (modal) {
            modal.open();
          } else {
            console.error('Bits addon modal not found');
          }
        });
      });
    }
  }

  customElements.define('bits-addon-trigger-block', BitsAddonTriggerBlock)
}
class BitsAddonModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.selectedProducts = new Map();
    this.currentFilter = 'all';
    this.previousActiveElement = null;
    this.bindEvents();
  }

  bindEvents() {
    // Close modal events
    this.querySelectorAll('[data-close-modal]').forEach(button => {
      button.addEventListener('click', this.closeModal.bind(this));
    });

    this.querySelector('.bits-addon-modal__overlay').addEventListener('click', this.closeModal.bind(this));

    // Filter pill events
    this.querySelectorAll('.bits-addon-modal__filter-pill').forEach(pill => {
      pill.addEventListener('click', this.switchFilter.bind(this));
    });

    // Product selection events
    this.querySelectorAll('.bits-addon-modal__product').forEach(product => {
      product.addEventListener('click', this.toggleProductSelection.bind(this));
    });

    // Add to bag button
    this.querySelector('[data-add-selected-to-cart]').addEventListener('click', this.addSelectedToCart.bind(this));

    // Keyboard events
    this.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  openModal() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.classList.add('bits-addon-modal--open');
    document.body.classList.add('bits-addon-modal-open');

    // Store the element that had focus before opening
    this.previousActiveElement = document.activeElement;

    // Focus the first filter pill
    const firstFilterPill = this.querySelector('.bits-addon-modal__filter-pill');
    if (firstFilterPill) {
      firstFilterPill.focus();
    }

    // Prevent body scroll
    document.body.classList.add('overflow-hidden');

    // Initialize selected products display
    this.updateSelectedProductsDisplay();

    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('bits-addon-modal:opened', {
      detail: { modal: this }
    }));
  }

  closeModal() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.classList.remove('bits-addon-modal--open');
    document.body.classList.remove('bits-addon-modal-open');

    // Restore focus to the previous element
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
      this.previousActiveElement = null;
    }

    // Restore body scroll
    document.body.classList.remove('overflow-hidden');

    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('bits-addon-modal:closed', {
      detail: { modal: this }
    }));
  }

  switchFilter(event) {
    const clickedPill = event.currentTarget;
    const filterValue = clickedPill.dataset.filter;

    // Update pill states
    this.querySelectorAll('.bits-addon-modal__filter-pill').forEach(pill => {
      pill.classList.remove('bits-addon-modal__filter-pill--active');
    });

    clickedPill.classList.add('bits-addon-modal__filter-pill--active');

    // Update current filter
    this.currentFilter = filterValue;

    // Filter products
    this.filterProducts();

    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('bits-addon-modal:filter-changed', {
      detail: {
        modal: this,
        filter: filterValue
      }
    }));
  }

  filterProducts() {
    const products = this.querySelectorAll('.bits-addon-modal__product');

    products.forEach(product => {
      const productSwatchGroup = product.dataset.swatchGroup;
      const shouldShow = this.currentFilter === 'all' || productSwatchGroup === this.currentFilter;

      if (shouldShow) {
        product.style.display = 'flex';
      } else {
        product.style.display = 'none';
      }
    });
  }

  toggleProductSelection(event) {
    const productElement = event.currentTarget;
    const productId = productElement.dataset.productId;
    const variantId = productElement.dataset.variantId;
    const productHandle = productElement.dataset.productHandle;

    if (this.selectedProducts.has(productId)) {
      // Remove from selection
      this.selectedProducts.delete(productId);
      productElement.classList.remove('bits-addon-modal__product--selected');
    } else {
      // Add to selection
      const priceElement = productElement.querySelector('.bits-addon-modal__product-price');
      const productData = {
        id: productId,
        variant: variantId,
        handle: productHandle,
        title: productElement.querySelector('.bits-addon-modal__product-title').textContent,
        price: priceElement.textContent,
        priceValue: parseInt(priceElement.dataset.productPrice, 10) || 0,
        image: productElement.querySelector('.bits-addon-modal__product-image img').src
      };
      this.selectedProducts.set(productId, productData);
      productElement.classList.add('bits-addon-modal__product--selected');
    }

    // Update selected products display
    this.updateSelectedProductsDisplay();

    // Update add to bag button
    this.updateAddToBagButton();

    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('bits-addon-modal:selection-changed', {
      detail: {
        modal: this,
        selectedProducts: Array.from(this.selectedProducts.values()),
        productId: productId,
        isSelected: this.selectedProducts.has(productId)
      }
    }));
  }

  updateSelectedProductsDisplay() {
    const selectionPanel = this.querySelector('.bits-addon-modal__selected-panel')
    const selectedContainer = this.querySelector('#selected-bits-container');

    if (this.selectedProducts.size === 0) {
      selectionPanel.classList.remove('active');
      selectedContainer.innerHTML = `
        <div class="bits-addon-modal__selected-empty">
          <p class="bits-addon-modal__selected-empty-text">No products selected</p>
        </div>
      `;
    } else {
      const selectedItemsHTML = Array.from(this.selectedProducts.values()).map(product => `
        <div class="bits-addon-modal__selected-item" data-product-id="${product.id}">
          <div class="bits-addon-modal__selected-item-image media media--transparent" style="padding-bottom: 100%;">
            <img src="${product.image}" alt="${product.title}" loading="lazy">
          </div>
          <button
            class="bits-addon-modal__selected-item-remove"
            type="button"
            data-remove-product="${product.id}"
            aria-label="Remove ${product.title}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="11.6293" cy="11.6293" r="11.6293" fill="#D9D9D9"/>
              <path d="M16.6991 6.56055L7.1571 16.1025" stroke="black"/>
              <path d="M16.6991 16.1025L7.1571 6.5606" stroke="black"/>
            </svg>
          </button>
        </div>
      `).join('');

      selectedContainer.innerHTML = selectedItemsHTML;
      selectionPanel.classList.add('active');

      // Bind remove events
      selectedContainer.querySelectorAll('[data-remove-product]').forEach(button => {
        button.addEventListener('click', this.removeSelectedProduct.bind(this));
      });
    }
  }

  removeSelectedProduct(event) {
    const productId = event.currentTarget.dataset.removeProduct;

    // Remove from selection
    this.selectedProducts.delete(productId);

    // Update product card - find it even if it's hidden by filter
    const productCard = this.querySelector(`.bits-addon-modal__product[data-product-id="${productId}"]`);
    if (productCard) {
      productCard.classList.remove('bits-addon-modal__product--selected');
    }

    // Update displays
    this.updateSelectedProductsDisplay();
    this.updateAddToBagButton();

    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('bits-addon-modal:selection-changed', {
      detail: {
        modal: this,
        selectedProducts: Array.from(this.selectedProducts.values()),
        productId: productId,
        isSelected: false
      }
    }));
  }

  updateAddToBagButton() {
    const button = this.querySelector('[data-add-selected-to-cart]');
    const countElement = button.querySelector('.bits-addon-modal__add-to-bag-count');
    const priceElement = button.querySelector('.bits-addon-modal__add-to-bag-price');

    const count = this.selectedProducts.size;
    const totalPrice = this.calculateTotalPrice();

    countElement.innerHTML = `&nbsp;(${count})`;
    priceElement.innerHTML = `&nbsp;&nbsp;|&nbsp;&nbsp;${totalPrice}`;

    if (count > 0) {
      button.disabled = false;
    } else {
      button.disabled = true;
    }
  }

  calculateTotalPrice() {
    let total = 0;
    this.selectedProducts.forEach(product => {
      // Use priceValue from data attribute if available, otherwise parse from price string
      if (product.priceValue) {
        total += product.priceValue / 100; // Convert from cents to dollars
      } else {
        // Fallback: Extract numeric value from price string (e.g., "$15.00" -> 15.00)
        const priceMatch = product.price.match(/[\d,]+\.?\d*/);
        if (priceMatch) {
          total += parseFloat(priceMatch[0].replace(',', ''));
        }
      }
    });

    // Format as currency, only show decimals if not .00
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(total);
    
    // Fail safe: Remove .00 if it's a whole number
    return formatted.replace(/\.00$/, '');
  }

  async addSelectedToCart(event) {
    const button = event.currentTarget;
    const selectedProducts = Array.from(this.selectedProducts.values());

    if (selectedProducts.length === 0) {
      return;
    }

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Prepare items array for bulk cart addition
      const items = selectedProducts.map(product => ({
        id: parseInt(product.variant, 10),
        quantity: 1,
        properties: {
          '_source': 'pdp_bit_upsell_experience'
        }
      }));

      // Add all selected products to cart in a single request
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Failed to add products to cart');
      }

      // Clear selections
      this.selectedProducts.clear();
      this.updateSelectedProductsDisplay();
      this.updateAddToBagButton();

      // close the drawer and update minicart & open it
      this.close();
      window.theme.fetchAndOpenCart()

      // Remove selection from product cards
      this.querySelectorAll('.bits-addon-modal__product--selected').forEach(card => {
        card.classList.remove('bits-addon-modal__product--selected');
      });

      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('bits-addon-modal:added-to-cart', {
        detail: {
          modal: this,
          products: selectedProducts,
          count: selectedProducts.length
        }
      }));

    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      // Reset button state
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  }

  // Public method to open modal from outside
  open() {
    this.openModal();
  }

  // Public method to close modal from outside
  close() {
    this.closeModal();
  }

  // Public method to get selected products
  getSelectedProducts() {
    return Array.from(this.selectedProducts.values());
  }

  // Public method to clear selections
  clearSelections() {
    this.selectedProducts.clear();
    this.updateSelectedProductsDisplay();
    this.updateAddToBagButton();

    // Remove selection from product cards
    this.querySelectorAll('.bits-addon-modal__product--selected').forEach(card => {
      card.classList.remove('bits-addon-modal__product--selected');
    });
  }
}

customElements.define('bits-addon-modal', BitsAddonModal);

// Global function to open bits addon modal
window.openBitsAddonModal = function() {
  const modal = document.querySelector('bits-addon-modal');
  if (modal) {
    modal.open();
  } else {
    console.error('Bits addon modal not found');
  }
};

if(!customElements.get('sizes-dropdown')) {
  class SizesDropdown extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.details?.querySelector('summary');
      this.content = this.details?.querySelector('.sizes-dropdown__content');
      this.drawer = null;
      this.previousIsMobile = this.isMobileViewport();
      
      // Handle window resize
      this.handleResize = this.handleResize.bind(this);
      window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
      const wasMobile = this.previousIsMobile;
      const isMobile = this.isMobileViewport();
      this.previousIsMobile = isMobile;
      
      // If switching from mobile to desktop, ensure details is closed
      if (wasMobile && !isMobile && this.drawer) {
        this.closeDrawer();
      }
    }

    isMobileViewport() {
      return window.innerWidth <= 749;
    }

    createDrawer() {
      if (this.drawer) {
        return this.drawer;
      }

      const drawer = document.createElement('div');
      drawer.classList.add('sizes-dropdown__drawer');
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-labelledby', 'sizes-drawer-title');
      drawer.setAttribute('aria-hidden', 'true');

      const title = 'OTHER SIZES AVAILABLE';
      
      const closeIcon = `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          class="icon icon-close"
          fill="none"
          viewBox="0 0 18 17"
        >
          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
        </svg>
      `;
      
      drawer.innerHTML = `
        <span class="sizes-dropdown__drawer__overlay" aria-hidden="true"></span>
        <div class="sizes-dropdown__drawer__content">
          <div class="sizes-dropdown__drawer__header">
            <h2 id="sizes-drawer-title" class="sizes-dropdown__drawer__title">${title}</h2>
            <button 
              type="button"
              class="sizes-dropdown__drawer__close"
              aria-label="Close sizes drawer"
            >
              ${closeIcon}
            </button>
          </div>
          <div class="sizes-dropdown__drawer__body">
            ${this.content ? this.content.cloneNode(true).innerHTML : ''}
          </div>
        </div>
      `;

      document.querySelector('#MainContent')?.appendChild(drawer) || document.body.appendChild(drawer);
      
      // Bind close events
      const closeButton = drawer.querySelector('.sizes-dropdown__drawer__close');
      const overlay = drawer.querySelector('.sizes-dropdown__drawer__overlay');
      
      closeButton?.addEventListener('click', () => this.closeDrawer());
      overlay?.addEventListener('click', () => this.closeDrawer());
      
      // Close on Escape key
      drawer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeDrawer();
        }
      });

      // Handle size selection clicks
      const sizeLinks = drawer.querySelectorAll('.sizes-dropdown__list a');
      sizeLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          // If it's not the active size, navigate and close drawer
          if (!link.classList.contains('active-size')) {
            setTimeout(() => this.closeDrawer(), 100);
          } else {
            e.preventDefault();
            this.closeDrawer();
          }
        });
      });

      this.drawer = drawer;
      return drawer;
    }

    openDrawer() {
      if (!this.isMobileViewport()) {
        return;
      }

      const drawer = this.createDrawer();
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      
      requestAnimationFrame(() => {
        drawer.classList.add('open');
      });

      // Focus management
      const closeButton = drawer.querySelector('.sizes-dropdown__drawer__close');
      closeButton?.focus();
    }

    closeDrawer() {
      if (!this.drawer) {
        return;
      }

      this.drawer.classList.remove('open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');

      setTimeout(() => {
        if (this.drawer && !this.drawer.classList.contains('open')) {
          this.drawer.remove();
          this.drawer = null;
        }
      }, 300);

      // Return focus to summary
      this.summary?.focus();
    }

    connectedCallback() {
      if (!this.details || !this.summary) {
        return;
      }

      // Handle summary click - show drawer on mobile, native behavior on desktop
      this.summary.addEventListener('click', (e) => {
        if (this.isMobileViewport()) {
          e.preventDefault();
          e.stopPropagation();
          // Close details if it was open
          if (this.details.hasAttribute('open')) {
            this.details.removeAttribute('open');
          }
          this.openDrawer();
        }
      });

      // Prevent details from opening on mobile - close immediately and show drawer
      this.details.addEventListener('toggle', () => {
        if (this.isMobileViewport() && this.details.hasAttribute('open')) {
          // Use setTimeout to close after the toggle event completes
          setTimeout(() => {
            this.details.removeAttribute('open');
            this.openDrawer();
          }, 0);
        }
      });

      // Close desktop dropdown when clicking outside
      this.handleClickOutside = (e) => {
        if (!this.isMobileViewport() && this.details.hasAttribute('open') && !this.contains(e.target)) {
          this.details.removeAttribute('open');
        }
      };
      document.addEventListener('click', this.handleClickOutside);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('click', this.handleClickOutside);
      if (this.drawer) {
        this.closeDrawer();
      }
    }
  }

  customElements.define('sizes-dropdown', SizesDropdown);
}

const initStickyATC = (() => {
  let activeObserver = null;

  return () => {
    if (activeObserver) {
      activeObserver.disconnect();
      activeObserver = null;
    }

    const sentinel = document.querySelector('.sticky-atc-observer');
    const stickyWrapper = document.querySelector('.product-form__wrapper.sticky-add-to-bag');
    if (!sentinel || !stickyWrapper) return;

    activeObserver = new IntersectionObserver(
      ([entry]) => {
        stickyWrapper.classList.toggle('is-sticky', !entry.isIntersecting);
      },
      { threshold: [0] }
    );

    activeObserver.observe(sentinel);
  };
})();

initStickyATC();
subscribe(PUB_SUB_EVENTS.variantChange, () => {
  requestAnimationFrame(initStickyATC);
});
